import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';

export const VENDA_ASSISTIDA_STORAGE = 'ROD-venda-assistida';


@Injectable({
	providedIn: 'root',
})
export class LocalStorageService {
	constructor(@Inject(PLATFORM_ID) private platformId: Object) {}
	private readonly OWNER_VIEW_KEY = 'ROD-owner-view';

	clear() {
		if (isPlatformBrowser(this.platformId)) {
			localStorage.clear();
		}
		return;
	}

	setItem(key: string, value: string) {
		if (isPlatformBrowser(this.platformId)) {
			localStorage.setItem(key, value);
		}
		return;
	}

	getItem(key: string) {
		if (isPlatformBrowser(this.platformId)) {
			return localStorage.getItem(key);
		}
		return;
	}

	removeItem(key: string) {
		if (isPlatformBrowser(this.platformId)) {
			localStorage.removeItem(key);
		}
	}

	hasItem(key: string): boolean {
		if (isPlatformBrowser(this.platformId)) {
			return localStorage.hasOwnProperty(key);
		}
		return false;
	}

	key(index: number) {
		if (isPlatformBrowser(this.platformId)) {
			return localStorage.key(index);
		}
		return;
	}

	length() {
		if (isPlatformBrowser(this.platformId)) {
			return localStorage.length;
		}
		return;
	}

public isOwnerView(): boolean {
    return this.getItem(this.OWNER_VIEW_KEY) === 'true';
}
}
